module.exports = __webpack_public_path__ + "img/rolling_stone.a5e6883b.jpg";